import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProductionService from "services/ProductionService";

export const initialState = {
  loading: false,
  message: "",
  list: null,
};

export const areaListAll = createAsyncThunk(
  "/area/list",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProductionService.getArea(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const areaSlice = createSlice({
  name: "area",
  initialState,
  reducers: {
    areaList: (state, action) => {
      state.loading = true;
      state.list = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(areaListAll.pending, (state) => {
        state.loading = false;
      })
      .addCase(areaListAll.fulfilled, (state, action) => {
        state.loading = true;
        state.list = action.payload;
      });
  },
});

export const { areaList } = areaSlice.actions;

export default areaSlice.reducer;
